import { ReactNode } from "react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";
import { clickZoomInImage, fileURL } from "../ApiS";
// import { clickZoomInImage, fileURL } from "../../Tools/APIs";

interface Identifiable {
  id: string | number;
  page?: string;
}

export interface TableOperation {
  name: string;
  icon: IconType;
  link?: boolean;
  onClick?: (id: string | number) => void;
}

export interface TableButtonLink {
  name: string;
  link: string;
  color?: string;
}

interface TableProps<T extends Identifiable> {
  tableHeads: string[];
  tableBody?: T[];
  keys: (keyof T)[];
  operations?: TableOperation[];
  page?: string;
  links?: TableButtonLink[];
  className ?: string
}

const Table = <T extends Identifiable>({
  tableHeads,
  tableBody,
  keys,
  operations,
  page,
  links,
  className
}: TableProps<T>) => {
  return (
    <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default sm:px-7.5 xl:pb-1 mx-5">
      <div className="max-w-full overflow-x-auto">
        <table className="w-full table-auto mx-auto">
          <thead className="">
            <tr className="bg-slate-200">
              {tableHeads.map((e, index) => (
                <th
                  key={index}
                  className={`min-w-[220px] py-4 px-4 font-medium text-black xl:pl-11 ${className}`}
                >
                  {e}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableBody?.map((item, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, colIndex) => (
                  <td
                    key={colIndex}
                    className="border-b border-[#eee] py-5 px-4 pl-9  xl:pl-11"
                  >
                    <div className="flex justify-center">
                      {key === "images" ? (
                        <img
                          onClick={clickZoomInImage}
                          src={(fileURL + item[key]) as string}
                          className="rounded-full w-12 h-12 cursor-pointer"
                          alt="Item"
                        />
                      ) : (
                        <p className="text-black ">{item[key] as string}</p>
                      )}
                    </div>
                  </td>
                ))}
                <td className="border-b border-[#eee] py-5 px-4 ">
                  <div className="flex items-center justify-around">
                    {operations?.map((operation) => (
                      <IconButton
                        key={operation.name}
                        onClick={operation.onClick}
                        id={item.id}
                        link={`${
                          operation.link && operation.name === "edit"
                            ? `${
                                page
                                  ? page + "/" + item.id + "/"
                                  : item.id + "/"
                              }edit`
                            : operation.link && operation.name === "show"
                            ? page
                              ? `${page}/${item.id}`
                              : `${item.id}`
                            : ""
                        }`}
                      >
                        <operation.icon
                          size={20}
                          color="#3c50e0"
                          className="cursor-pointer hover:text-primary"
                        />
                      </IconButton>
                    ))}
                  </div>
                </td>
                {links && (
                  <td className="border-b border-[#eee] py-5 px-4 ">
                    <div className="flex flex-col items-center justify-around">
                      {links?.map((l) => (
                        <Link
                          to={l.name==="المقررات" ? l.link  : item.id + "/" + l.link}
                          className={`text-white font-semibold w-[140px] text-center rounded-lg px-4 py-1 my-1 text-base bg-blue-800`}
                        >
                          {l.name}
                        </Link>
                      ))}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;

interface IconButtonProps {
  children: ReactNode;
  link: string;
  id: string | number;
  onClick?: (id: string | number) => void;
}

const IconButton = ({ children, link, onClick, id }: IconButtonProps) => {
  const handleClick = () => {
    if (onClick) onClick(id);
  };

  return link ? (
    <Link to={link} className="p-2 rounded-full hover:bg-slate-200">
      {children}
    </Link>
  ) : (
    <button
      onClick={handleClick}
      className="p-2 rounded-full hover:bg-slate-200"
    >
      {children}
    </button>
  );
};
